import {
  BadgedLink,
  Button,
  Checkbox,
  Flex,
  Heading1,
  Icon,
  IconArrowLeftSmallOutline,
  IconLockSmallFilled,
  Input,
  TextSmall,
} from '@teamleader/ahoy';
import { translate } from '@teamleader/i18n';
import React from 'react';
import { Field, FormRenderProps } from 'react-final-form';
import { getFormFieldErrorFromMeta } from '../../../Infrastructure/Forms/utils';
import styles from './styles.css';

interface TotpProps {
  formRenderProps: FormRenderProps;
  onGoBackToLoginClick: () => void;
  onChooseAnotherMethodClick: () => void;
  isRedirecting: boolean;
}

const Totp = ({ formRenderProps, onGoBackToLoginClick, onChooseAnotherMethodClick, isRedirecting }: TotpProps) => {
  const { submitting, submitError } = formRenderProps;

  return (
    <Flex direction="column" alignItems="stretch">
      <BadgedLink
        className={styles.back}
        onClick={onGoBackToLoginClick}
        inherit={false}
        icon={<IconArrowLeftSmallOutline />}
      >
        <TextSmall>{translate('mfa.goBackToLogin')}</TextSmall>
      </BadgedLink>

      <Flex direction="column" alignItems="flex-start" gap={2} marginBottom={5}>
        <Heading1>{translate('mfa.totpTitle')}</Heading1>

        <TextSmall color="neutral" tint="darkest">
          {translate('mfa.totpDescription')}
        </TextSmall>
      </Flex>

      <Field name="mfaCode">
        {({ input, meta }) => {
          return (
            <Input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              autoComplete="one-time-code"
              autoFocus
              placeholder={translate('code')}
              prefix={
                <Icon color="neutral" tint="darkest">
                  <IconLockSmallFilled />
                </Icon>
              }
              {...input}
              error={getFormFieldErrorFromMeta(meta)}
              size="large"
              marginBottom={2}
            />
          );
        }}
      </Field>

      {submitError && (
        <TextSmall color="ruby" tint="dark">
          {submitError}
        </TextSmall>
      )}

      <Flex direction="column" alignItems="stretch" gap={3} marginTop={6}>
        <Field name="trusted" initialValue={false}>
          {({ input }) => {
            return (
              <Checkbox
                label={translate('trustDevice', { amountOfDays: 7 })}
                onChange={input.onChange}
                checked={input.value}
                alignSelf="flex-start"
              />
            );
          }}
        </Field>

        <Button size="large" level="primary" fullWidth type="submit" processing={submitting || isRedirecting}>
          {translate('mfa.validateAndLogin')}
        </Button>

        <Button size="medium" level="link" fullWidth onClick={onChooseAnotherMethodClick} type="submit">
          {translate('mfa.useADifferentMethod')}
        </Button>
      </Flex>
    </Flex>
  );
};

export default Totp;
